import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c44cb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "ws_drawer_footer" }

import { ref, watch, nextTick, computed } from 'vue'
import { deviceConfInfoUpdate, queryDeviceConfInfoDetail } from '@/api'
import { isEmpty } from 'lodash'
import type { FormInstance } from 'element-plus'
import { CODE_ENUM, SUFFIX, PRODUCT_TYPE } from '@/common'
import { ElMessage } from 'element-plus'
import { cloneDeep } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'conf-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const options = [
  {
    value: 'SKY',
    label: 'SKY',
  },
  {
    value: 'SPT',
    label: 'SPT',
  },
]

const formData: any = ref({
  confList: [
    {
      configCode: '',
      deviceKey: '',
      deviceSecret: '',
      opDevicedSn: '',
    },
    {
      configCode: '',
      deviceKey: '',
      deviceSecret: '',
      opDevicedSn: '',
    },
  ],
})




watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryDetail()
    }
  }
)

const queryDetail = async () => {
  const res: any = await queryDeviceConfInfoDetail({
    deviceId: props.data.deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { confList } = formData.value
    const moConfList = res.data
      .concat(cloneDeep(confList))
      .filter((_: any, i: number) => i <= 1)
    formData.value.confList = moConfList
  }
}

const validateConf = (index: number) => {
  return (rule: any, value: any, callback: any) => {
    const { configCode, deviceKey, deviceSecret, opDevicedSn } =
      formData.value.confList[index]
    if (
      isEmpty(value) &&
      (configCode || deviceKey || deviceSecret || opDevicedSn)
    ) {
      callback('请输入完整配置或者清除已填选项')
    } else {
      callback()
    }
  }
}

const validateCode = (rule: any, value: any, callback: any) => {
  const { confList } = formData.value
  if (
    confList[0].configCode === confList[1].configCode &&
    !isEmpty(confList[0].configCode)
  ) {
    callback('两组配置code不能相同')
  } else {
    callback()
  }
}
const loading = ref(false)
const formRef: any = ref<FormInstance>()
const handleSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      loading.value = true
      const { confList } = formData.value
      const moConfList = confList.filter((_: any) => Boolean(_.configCode))
      const res: any = await deviceConfInfoUpdate({
        confList: moConfList,
        deviceId: props.data.deviceId,
      })
      loading.value = false
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage.success(res?.msg)
        handleClose()
        $emit('success')
      }
    }
  })
}

const handleClose = () => {
  $emit('update:visible', false)

  formData.value = {
    confList: [
      {
        configCode: '',
        deviceKey: '',
        deviceSecret: '',
        opDevicedSn: '',
      },
      {
        configCode: '',
        deviceKey: '',
        deviceSecret: '',
        opDevicedSn: '',
      },
    ],
  }
  formRef.value.resetFields?.()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: "编辑配置",
    "before-close": handleClose,
    size: "480px"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: handleSubmit,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 保存 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        "label-width": "100",
        "label-position": "left"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.confList, (domain, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: {"margin-bottom":"40px"}
            }, [
              _createElementVNode("p", _hoisted_1, "配置" + _toDisplayString(Number(index + 1)), 1),
              _createVNode(_component_el_form_item, {
                prop: 'confList.' + index + '.configCode',
                rules: [
            {
              validator: validateConf(index),
            },
            {
              validator: validateCode,
            },
          ],
                label: "配置code"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: domain.configCode,
                    "onUpdate:modelValue": ($event: any) => ((domain.configCode) = $event),
                    class: "ws_select_form",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop", "rules"]),
              _createVNode(_component_el_form_item, {
                prop: 'confList.' + index + '.deviceKey',
                rules: [
            {
              validator: validateConf(index),
            },
          ],
                label: "配置key"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: domain.deviceKey,
                    "onUpdate:modelValue": ($event: any) => ((domain.deviceKey) = $event),
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop", "rules"]),
              _createVNode(_component_el_form_item, {
                prop: 'confList.' + index + '.deviceSecret',
                rules: [
            {
              validator: validateConf(index),
            },
          ],
                label: "配置秘钥"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: domain.deviceSecret,
                    "onUpdate:modelValue": ($event: any) => ((domain.deviceSecret) = $event),
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop", "rules"]),
              _createVNode(_component_el_form_item, {
                prop: 'confList.' + index + '.opDevicedSn',
                rules: [
            {
              validator: validateConf(index),
            },
          ],
                label: "SN"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: domain.opDevicedSn,
                    "onUpdate:modelValue": ($event: any) => ((domain.opDevicedSn) = $event),
                    placeholder: "第三方平台的设备sn",
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop", "rules"])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})